import axios from "./axios";

export default class CardsService {
  static addNewCard(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/card/registration', payload);
  }

  static getCardsList() {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/card/list');
  }

  static setDefaultCard(card_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/default-card', {card_id});
  }

  static deleteCard(card_id) {
    return axios.post(window.entityCabinetSettings.openApi.url + `/api/card/delete/${card_id}`);
  }
}
